"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootVariant = function (classes, variant) {
    switch (variant) {
        case "error":
            return classes.rootError || '';
        case "warning":
            return classes.rootWarning || '';
        case "success":
            return classes.rootSuccess || '';
        case "info":
        default:
            return classes.rootInfo || '';
    }
};
exports.getIconContainerVariant = function (classes, variant) {
    switch (variant) {
        case "error":
            return classes.iconContainerError || '';
        case "warning":
            return classes.iconContainerWarning || '';
        case "success":
            return classes.iconContainerSuccess || '';
        case "info":
        default:
            return classes.iconContainerInfo || '';
    }
};
